export const MIN_PLAYERS_TO_START = 2;
export const MAX_PLAYERS_PER_ROOM = 7;